export default "__VITE_PUBLIC_ASSET__f71f748b__"